import { Injectable } from '@angular/core';
import { TranslateLoader, TranslationObject } from '@ngx-translate/core';
import { from, Observable } from 'rxjs';

@Injectable()
export class WebpackTranslationLoader implements TranslateLoader {
  // eslint-disable-next-line rxjs-x/finnish
  public getTranslation(lang: string): Observable<TranslationObject> {
    return from(import(`./i18n/generated/${lang}.json`));
  }
}
